import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.52 4.73c-.29.29-.29.77 0 1.06l6.97 6.97-6.97 6.97c-.29.29-.29.77 0 1.06s.77.29 1.06 0l7.5-7.5c.29-.29.29-.77 0-1.06l-7.5-7.5a.754.754 0 0 0-1.06 0"
}));
const ForwardRef = forwardRef(SvgComponent);
export const ChevronRightIcon = ForwardRef;